/* eslint-disable @typescript-eslint/no-explicit-any */
import { Input } from "antd"
import { typeConvert } from "./BodyParams"

const PathParams = ({ pathParams, setData, values }: { pathParams: any, setData: any, values: any }) => {
  return <div className="">
    <div className="font-semibold mb-1 text-[14px]">
      Path Params
    </div>
    <div className="border bg-[#fafafa] p-3 rounded ">
      {
        pathParams?.map((param, index) => {
          return <div className="flex justify-between mb-3 gap-3" key={index}>
            <div >
              <div className="flex justify-between">
                <div className="flex gap-2 items-center text-[16px]">
                  <span className="font-semibold   max-w-[140px]  2xl:max-w-[400px]  text-ellipsis overflow-hidden" title={param.name}>{param.name}</span>
                  <span className="text-[#B8BABD]">{param.type}</span>
                  <span className="text-[#dd1e2e]">{param.required ? 'required' : ''}</span>
                </div>
              </div>
              <div>
                <div className="text-[14px] text-[#777A80]  2xl:max-w-[400px] max-w-[250px]">
                  {
                    param.description
                  }
                </div>
              </div>
            </div>

            <div>
              <Input value={values?.[param.name] || ''} onChange={(e) => {
                setData('path', {
                  [param.name]: typeConvert(param.type, e.target.value)
                })
              }}
                type={param.type === 'boolean' ? 'checkbox' : 'text'}
              />
            </div>
          </div>
        })
      }
    </div>
  </div>
}

export default PathParams